import React, { useState } from 'react';
import Title from '../../shared/Title/Title';
import CashiersBalance from './Cashiers/Cashiers';
import TerminalsBalance from './Terminals/Terminals';
import { getTranslation } from '../../../utils/translation';

const tabs = {
    cashier: 1,
    terminals: 2,
};

const Balance = () => {
    const [selectedTab, setSelectedTab] = useState(tabs.cashier);

    const onTabChange = tab => {
        setSelectedTab(tab);
    };

    return (
        <>
            <Title title={getTranslation('title.weeklyBalance')} />
            <div className='filters-nav'>
                <button
                    className={`filter-tab ${selectedTab === tabs.cashier ? 'active' : ''}`}
                    onClick={() => onTabChange(tabs.cashier)}
                >
                    {getTranslation('balanceReportsTabsCashier')}
                </button>
                <button
                    className={`filter-tab ${selectedTab === tabs.terminals ? 'active' : ''}`}
                    onClick={() => onTabChange(tabs.terminals)}
                >
                    {getTranslation('balanceReportsTabsTerminals')}
                </button>
            </div>

            {selectedTab === tabs.cashier ? <CashiersBalance /> : <TerminalsBalance />}
        </>
    );
};

export default Balance;
